import { round } from "./state.js";
import { MAX_TRIES, arrowSvg } from "./hint.js";
import { fmt, escapeHtml } from "./util.js";

const cardEl = document.getElementById("card");

function buildRowsHtml() {
  let rowsHtml = "";
  for (let i = 0; i < MAX_TRIES; i++) {
    const g = round.guesses[i];
    rowsHtml += g
      ? `<div class="row filled">
           <div class="n">${i + 1}</div>
           <div class="val">${fmt(g.guess, round.item.currency)}</div>
           <div class="hint-group">
             <span class="hint-text ${g.hint.cls}" data-heat="${g.hint.tier}">${g.hint.text}</span>
             <div class="arrow ${g.hint.cls}">${arrowSvg(g.hint.cls)}</div>
           </div>
         </div>`
      : `<div class="row empty">
           <div class="n">${i + 1}</div>
           <div class="val">—</div>
           <div class="arrow-placeholder" aria-hidden="true"></div>
         </div>`;
  }
  return rowsHtml;
}

function wireThumbs() {
  cardEl.querySelectorAll(".thumb").forEach(btn => {
    btn.addEventListener("click", () => {
      const imgs = round.images && round.images.length ? round.images : [round.item.imgUrl];
      const idx = Math.min(Math.max(parseInt(btn.dataset.idx, 10) || 0, 0), imgs.length - 1);
      round.activeImg = idx;
      const mainImg = document.getElementById("mainImg");
      if (mainImg) mainImg.src = imgs[idx];
      cardEl.querySelectorAll(".thumb").forEach((b, i) => b.classList.toggle("active", i === idx));
    });
  });
}

function wireZoom() {
  const mainImg = document.getElementById("mainImg");
  if (!mainImg) return;
  const wrap = mainImg.closest(".imgwrap");
  wrap.addEventListener("mouseenter", () => wrap.classList.add("zooming"));
  wrap.addEventListener("mouseleave", () => {
    wrap.classList.remove("zooming");
    wrap.style.removeProperty("--ox");
    wrap.style.removeProperty("--oy");
  });
  wrap.addEventListener("mousemove", (e) => {
    const r = wrap.getBoundingClientRect();
    const x = ((e.clientX - r.left) / r.width) * 100;
    const y = ((e.clientY - r.top) / r.height) * 100;
    wrap.style.setProperty("--ox", x + "%");
    wrap.style.setProperty("--oy", y + "%");
  });
}

export function showSkeleton() {
  cardEl.innerHTML = `<div class="skeleton">Loading listing…</div>`;
}

export function showError(msg) {
  cardEl.innerHTML = `<div class="errorbox">${escapeHtml(msg)}</div>`;
}

export function render(onGuess) {
  if (!round.item) return;
  const { item, done } = round;
  const imgs = round.images && round.images.length ? round.images : [item.imgUrl];
  const activeUrl = imgs[round.activeImg || 0] || item.imgUrl;
  const thumbSrc = (u) => u.replace(/s-l\d+\.(jpg|webp|png)/i, "s-l300.jpg");
  const thumbsHtml = imgs.length > 1
    ? `<div class="thumbs">${imgs.map((u, i) => `
        <button class="thumb ${i === (round.activeImg || 0) ? "active" : ""}" data-idx="${i}" type="button">
          <img src="${thumbSrc(u)}" alt="" loading="lazy" decoding="async" referrerpolicy="no-referrer" />
        </button>`).join("")}</div>`
    : "";

  cardEl.innerHTML = `
    <div class="gallery">
      ${thumbsHtml}
      <div class="imgwrap"><img id="mainImg" src="${activeUrl}" alt="" referrerpolicy="no-referrer" onerror="this.style.opacity=0.3" /></div>
    </div>
    <div class="info">
      <div class="cat">${escapeHtml(item.keyword || "eBay listing")}</div>
      <h2 class="title">${escapeHtml(item.title)}</h2>
    </div>
    <div class="rows">${buildRowsHtml()}</div>
    <form class="form" id="guessForm">
<div class="input-wrap">
        <span class="cur">${item.currency || "$"}</span>
        <input id="guess" type="number" min="0" step="0.01" inputmode="decimal" autocomplete="off" placeholder="Your guess" ${done ? "disabled" : ""} />
      </div>
      <button class="aqua-btn" type="submit" ${done ? "disabled" : ""}>Guess</button>
    </form>
  `;

  const form = document.getElementById("guessForm");
  const inp = document.getElementById("guess");
  if (!done) {
    form.addEventListener("submit", (e) => { e.preventDefault(); onGuess(inp.value); });
    inp.focus();
  } else {
    form.addEventListener("submit", (e) => e.preventDefault());
  }

  wireThumbs();
  wireZoom();
}
